import { combineReducers } from "redux";

import LeadReducer from "./API/lead/lead.reducer";
import OrderReducer from "./API/order/order.reducer";
import ContentReducer from "./API/content/content.reducer";
import ProductReducer from "./API/product/product.reducer";
import ProductCategoryReducer from "./API/productCategories/productCategories.reducer";
import CallBackReducer from "./features/callback/callBackSlice";
import LocalFormReducer from "./local/form.reducer";
import PopupsReducer from "./API/popup/popup.reducer";

export default combineReducers({
  lead: LeadReducer,
  order: OrderReducer,
  product: ProductReducer,
  content: ContentReducer,
  productCategories: ProductCategoryReducer,
  callBackReducer: CallBackReducer,
  form: LocalFormReducer,
  popups: PopupsReducer,
});
